var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtstation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 461 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-25,1.42109e-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32_7-artstation"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26,365.896L64.925,433.157C72.62,448.365 88.279,458.774 106.475,458.774L364.832,458.774L311.241,365.896L26,365.896ZM478.44,341.094L327.989,77.938C320.204,63.274 304.724,53.225 286.89,53.225L206.867,53.225L439.786,458.411L476.629,394.593C478.35,391.697 495.64,367.706 478.44,341.094ZM273.131,299.903L168.576,118.856L64.02,299.903L273.131,299.903Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtstation);
export default __webpack_public_path__ + "static/media/artstation.3482903e064b2ec7f786cc55ab8cf883.svg";
export { ForwardRef as ReactComponent };